import { render, staticRenderFns } from "./specs1.vue?vue&type=template&id=db67750e&scoped=true&"
import script from "./specs1.vue?vue&type=script&lang=js&"
export * from "./specs1.vue?vue&type=script&lang=js&"
import style0 from "./specs1.vue?vue&type=style&index=0&id=db67750e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db67750e",
  null
  
)

export default component.exports